module.exports = __webpack_public_path__ + "static/media/loader.f62ba570.svg";